import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHeroSection, setIsHeroSection] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    // Intersection Observer for Hero section
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        setIsHeroSection(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    const heroSection = document.getElementById('home');
    if (heroSection) {
      heroObserver.observe(heroSection);
    }

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (heroSection) {
        heroObserver.unobserve(heroSection);
      }
    };
  }, []);

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''} ${isHeroSection ? 'hero-section' : ''}`}>
      <div className="container mx-auto px-4">
        <div className="nav-content">
          {/* Logo */}
          <div className="logo">
            <img 
              src="/logo.png" 
              alt="Kaçkar Karafırın Logo" 
              className="h-12 md:h-14 w-auto"
              onLoad={() => console.log('Logo loaded successfully')}
              onError={(e) => console.error('Logo failed to load:', e)}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="nav-links">
            <a href="#home" className="nav-link">Ana Sayfa</a>
            <a href="#about" className="nav-link">Hakkımızda</a>
            <a href="#products" className="nav-link">Ürünler</a>
            <a href="#services" className="nav-link">Hizmetler</a>
            <a href="#contact" className="nav-link">İletişim</a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="mobile-nav">
            <div className="mobile-nav-content">
              <a href="#home" className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                Ana Sayfa
              </a>
              <a href="#about" className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                Hakkımızda
              </a>
              <a href="#products" className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                Ürünler
              </a>
              <a href="#services" className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                Hizmetler
              </a>
              <a href="#contact" className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                İletişim
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation; 